import { ShopMission } from '@/schema/shop';

export function getShopMissionsToShow(
  missions: ShopMission[],
  soldCount: number,
): ShopMission[] {
  // 달성한 미션: soldCount가 mission.section보다 큰 미션
  const achievedMissions = missions.filter(
    mission => soldCount >= mission.section,
  );

  // 달성하지 못한 미션: soldCount가 mission.section보다 작은 미션
  const notAchievedMissions = missions.filter(
    mission => soldCount < mission.section,
  );

  // 미션들을 section을 기준으로 정렬 (오름차순)
  achievedMissions.sort((a, b) => a.section - b.section);
  notAchievedMissions.sort((a, b) => a.section - b.section);

  // 결과를 저장할 배열
  let result: ShopMission[] = [];

  // 모두 달성하지 못한 경우
  if (achievedMissions.length === 0) {
    result = notAchievedMissions.slice(0, 2); // section이 작은 미션 2개
  }
  // 달성한 미션이 있고, 달성하지 못한 미션도 있을 때
  else if (achievedMissions.length > 0 && notAchievedMissions.length > 0) {
    result.push(achievedMissions[achievedMissions.length - 1]); // 달성한 것 중 section이 가장 큰 것
    result.push(notAchievedMissions[0]); // 달성하지 못한 것 중 section이 가장 작은 것
  }
  // 모든 미션을 달성한 경우
  else if (notAchievedMissions.length === 0) {
    result = achievedMissions.slice(-2); // section이 큰 미션 2개
  }

  return result;
}
